<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="printingFormState" @submit.prevent="printOnNewTab">
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>

              <v-flex xs3>
                <v-btn
                  class="success"
                  @click.prevent="days = 1"
                >
                  Сегодня
                </v-btn>
              </v-flex>

              <v-flex xs3>
                <v-btn
                  class="success"
                  @click.prevent="days = 7"
                >
                  Неделя
                </v-btn>
              </v-flex>

              <v-flex xs3>
                <v-btn
                  class="success"
                  @click.prevent="days = 31"
                >
                  Месяц
                </v-btn>
              </v-flex>

              <v-flex xs12>
                <validate>
                  <v-text-field
                    v-model.number="days"
                    type="number"
                    name="days"
                    label="Количество дней"
                    hide-details
                    :min="1"
                    required
                  />
                  <field-messages
                    name="days"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Days is a required field
                    </small>
                    <small class="error--text" slot="min">
                      Min > 0
                    </small>
                  </field-messages>
                </validate>
              </v-flex>

              <v-flex xs12>
                <v-switch v-model="includeExpired" :label="includeExpired ? 'Включая просроченные' : 'Не включая просроченные'"></v-switch>
              </v-flex>

            </v-layout>
          </v-container>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Закрыть
              </v-btn>
              <v-btn type="submit" color="success">
                Печать
              </v-btn>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'printingPopup',
  props: {
    dialog: {
      type: Boolean,
      default: () => false,
    },
    printing_type: {
      type: String,
      default: () => 'analyses',
    }
  },
  data() {
    return {
      days: 1,
      includeExpired: false,
      printingFormState: {}
    };
  },
  computed: {
    title() {
      let type_ = this.printing_type === 'analyses'
        ? 'анализов'
        : (this.printing_type === 'mixes' ? 'миксов' : '');
      return `Печать ${type_}`;
    },
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
  methods: {
    close() {
      this.days = 1;
      this.includeExpired = false;
      this.printingFormState._reset();
      this.dialogLocal = false;
    },
    async printOnNewTab() {
      window.open(`api/v2/pdf/batch/${this.printing_type}?days=${this.days}&includeExpired=${this.includeExpired}`, '_blank');
      this.close();
    },
  },
};
</script>
